import { RowCenter } from 'layout/Components/Row'
import styled from 'styled-components'
import { Icons } from 'svgs'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import IconButton from 'UIKit/Button/IconButton'

const BackButton = ({ onClick, ...props }: { onClick: () => void } & BoxProps) => {
  return (
    <RowCenter width="24px" height="24px" minWidth="24px" minHeight="24px" mr="10px" {...props}>
      <StyledButton width="32px" height="32px" style={{ position: 'relative' }} className="back-btn" onClick={onClick}>
        <BackIcon width="22px" height="22px" />

        <Box
          position={['absolute', 'absolute', 'unset']}
          top="-16px"
          bottom="-16px"
          left="-20px"
          right="-20px"
          borderRadius="50%"
        />
      </StyledButton>
    </RowCenter>
  )
}

const StyledButton = styled(IconButton)`
  svg {
    margin-left: -6px;
    width: 20px;
    height: 20px;
    fill: none !important;
  }
  &:hover {
    svg {
      fill: none !important;
    }
  }
`

export const BackIcon = styled(Icons.ChevronLeftV2Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`

export default BackButton
